<template>
  <div class="luck2022">
    <div class="luck2022__menu">
      <lpMenu
        :menu="menu"
        :imgPath="imgPath"
        :subscription-flg="subscriptionFlg"
        :is-hoshi-hitomi="isHoshiHitomi"
      />
    </div>
    <div class="luck2022__form">
      <lpForm
        :menu="menu"
        :csrf-token="csrfToken"
        :my-nickname="myNickname"
        :my-birthday="myBirthday"
        :my-gender="myGender"
        :subscription-flg="subscriptionFlg"
        :is-hoshi-hitomi="isHoshiHitomi"
      />
    </div>
    <div class="luck2022__subsc" v-if="!subscriptionFlg && !isHoshiHitomi">
      <prSubsc
        :imgPath="imgPath"
        :sbscUrl="sbscUrl"
      />
    </div>
  </div>
</template>

<script>
import lpMenu from "./lpMenu";
import lpForm from "./lpForm";
import prSubsc from "./prSubsc";

export default {
  name: "Yearluck2022Lp",
  components: {
    lpMenu,
    lpForm,
    prSubsc,
  },
  data() {
    return {
      imgPath: '/static/img/yearluck/y2022/',
      elWidth: 375,
    }
  },
  props: {
    menu: {
      type: Object,
      default () {
        return {}
      }
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    myNickname: {
      type: String,
      default() {
        return ''
      }
    },
    myBirthday: {
      type: String,
      default() {
        return ''
      }
    },
    myGender: {
      type: String,
      default: '',
    },
    subscriptionFlg: {
      type: Boolean,
      default: false
    },
    sbscUrl: {
      type: String,
      default: '/user/login'
    },
  },
  computed: {
    // 星ひとみ　かどうか
    isHoshiHitomi() {
      return (/6201/.test(this.menu.menu_id) || /6301/.test(this.menu.menu_id))
    },
  },
}
</script>

<style scoped lang="scss">
.luck2022 {
  padding: 0 0 60px;
  &__menu {}
  &__form {}
  &__subsc {
    margin: 10.7% auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/yearluck2022Lp.vue